// extracted by mini-css-extract-plugin
export default {"wrapper":"CollectionWidget_wrapper__NX+e4"};